import {Component, inject}                  from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

@Component({
			   selector   : 'app-ui-snack',
			   imports    : [],
			   templateUrl: './ui-snack.component.html',
			   styleUrl   : './ui-snack.component.css'
		   })
export class UiSnackComponent {

	data: {
		message: string
	} = inject(MAT_SNACK_BAR_DATA)

	snack: MatSnackBarRef<UiSnackComponent> = inject(MatSnackBarRef)
}
